import packageJson from '../../package.json'

const version = packageJson.version

export { version as APP_VERSION }
